export const ADD_PIPELINES = 'ADD_PIPELINES'
export const LOAD_PIPELINE_STATUS_ENUM = 'LOAD_PIPELINE_STATUS_ENUM'
export const LOAD_PIPELINE_PRIORITY_ENUM = 'LOAD_PIPELINE_PRIORITY_ENUM'
export const LOAD_PIPELINE_HISTORY_CONTEXT_ENUM = 'LOAD_PIPELINE_HISTORY_CONTEXT_ENUM'
export const LOAD_PIPELINE_STATES = 'LOAD_PIPELINE_STATES'
export const SET_CURRENT_PIPELINE = 'SET_CURRENT_PIPELINE'
export const LOAD_PIPELINE_FEELING_ENUM = 'LOAD_PIPELINE_FEELING_ENUM'
export const LOAD_SALES_PERSONS = 'LOAD_SALES_PERSONS'
export const LOAD_PIPELINES = 'LOAD_PIPELINES'
export const LOAD_ACTIVITY_REMIND_ENUM = 'LOAD_ACTIVITY_REMIND_ENUM'